if (!customElements.get('discount-code-field')) {
  customElements.define(
    'discount-code-field',
    class DiscountCodeField extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          form: this.querySelector('form'),
          submitButton: this.querySelector('button[type="submit"]'),
          buttonSpinnerWrap: this.querySelector('button[type="submit"] .discount-code__spinner-wrap'),
          buttonSpinner: this.querySelector('button[type="submit"] .loading__spinner'),
          errorMessage: this.querySelector('.discount-code-field__error-message'),
          discountInput: this.querySelector('input[name="discount"]'),
        };

        this.registerEventListeners();
      }

      registerEventListeners() {
        this.elements.form.addEventListener('submit', this.onSubmit.bind(this));
        // hide error message on input
        this.elements.discountInput.addEventListener('input', () => {
          this.elements.errorMessage.style.display = 'none';
        });
      }

      setLoadingState(isLoading) {
        if (isLoading) {
          this.elements.submitButton.disabled = true;
          this.elements.buttonSpinner.classList.remove('hidden');
          this.elements.buttonSpinnerWrap.classList.remove('hidden');
        } else {
          this.elements.submitButton.disabled = false;
          this.elements.buttonSpinner.classList.add('hidden');
          this.elements.buttonSpinnerWrap.classList.add('hidden');
        }
      }

      onSubmit(event) {
        event.preventDefault();

        const formData = new FormData(this.elements.form);
        const discountCode = formData.get('discount').trim();

        // Bail if no discount code.
        if (!discountCode) return;

        this.setLoadingState(true);

        addRemoveDiscountCodes([discountCode], [])
          .then((response) => {
            // Check if accepted
            const result = response?.discount_codes || [];

            const isAccepted = result
              .filter((code) => String(code.code).toLowerCase() === String(discountCode).toLowerCase())
              .some((code) => code.applicable);

            if (!isAccepted) {
              this.elements.errorMessage.style.display = 'block';
            } else {
              // reset the form
              this.elements.form.reset();

              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'discount-code-field' });
            }
          })
          .catch((error) => {
            console.error('Error applying discount code:', error);
            // Show error message
            this.elements.errorMessage.style.display = 'block';
          })
          .finally(() => {
            this.setLoadingState(false);
          });
      }
    },
  );
}
